import React from "react"
import id from "@irati/utils/id"
import {Deal, DealType} from "@irati/types"
import DealSavingsTypes from "@irati/deals/types/enums/DealSavingsType"
import styled from "styled-components"
import Amount from "./Amount"
import Free from "./Free"
import SpecialRates from "./SpecialRates"

type Props = {
  deal: Deal
  allowEarnPointsModal?: boolean
}

const SavingsWrapper = styled.div`
  text-align: right;
  display: flex;
  align-items: center;
  justify-content: flex-end;
`

const Saving = ({allowEarnPointsModal, deal}: Props) => {
  if (deal.type === DealType.Company) return null

  const idNamespace = id("saving", {id: deal.uuid})
  const {userSavings} = deal.savings || {}

  return (
    <SavingsWrapper data-test="savings">
      {userSavings?.type === DealSavingsTypes.SPECIAL_RATES ? (
        <SpecialRates id={id("special-rates", idNamespace)} />
      ) : userSavings?.type === DealSavingsTypes.FREE ? (
        <Free id={id("free", idNamespace)} emoji={""} />
      ) : (
        <Amount deal={deal} allowEarnPointsModal={allowEarnPointsModal} />
      )}
    </SavingsWrapper>
  )
}

export default Saving
